import React from "react";
import { Menu } from "lucide-react";
import { ReactComponent as Icon } from "assets/icon/icon-inverted.svg";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const Navigation = ({ isMenuOpen, setIsMenuOpen }: { isMenuOpen: boolean; setIsMenuOpen: (open: boolean) => void }) => {
	const { i18n, t } = useTranslation();
	const location = useLocation();

	const switchLanguage = () => {
		const newLang = i18n.language === "en" ? "zh" : "en";
		const newPath = newLang === "zh" ? `/zh${location.pathname.replace("/zh", "")}` : location.pathname.replace("/zh", "");
		i18n.changeLanguage(newLang);
		window.location.pathname = newPath;
	};

	const getLocalizedPath = (path: string) => {
		return i18n.language === "zh" ? `/zh${path}` : path;
	};

	return (
		<nav className="fixed w-full bg-white shadow-md z-50">
			<div className="container mx-auto px-6 py-3">
				<div className="flex items-center justify-between">
					<div
						className="text-2xl font-bold bg-gradient-to-r bg-clip-text text-transparent flex items-center space-x-2"
						style={{ color: "#111827" }}>
						<style>
							{`div .s0{
								fill: #111827;
							}`}
						</style>
						<Icon className="h-8 w-8" />
						<span>{t("MiChat")}</span>
					</div>
					<div className="md:hidden">
						<button onClick={() => setIsMenuOpen(!isMenuOpen)}>
							<Menu className="h-6 w-6" />
						</button>
					</div>
					<div className="hidden md:flex items-center space-x-8">
						<a
							href={getLocalizedPath("#features")}
							className="text-gray-600 hover:text-gray-900">
							{t("Features")}
						</a>
						<a
							href={getLocalizedPath("#pricing")}
							className="text-gray-600 hover:text-gray-900">
							{t("Pricing")}
						</a>
						<a
							href={getLocalizedPath("#contact")}
							className="text-gray-600 hover:text-gray-900">
							{t("Contact")}
						</a>
						<a href="/app/">
							<button className="bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 transition duration-300">{t("Log In")}</button>
						</a>
						<button
							onClick={switchLanguage}
							className="text-gray-600 hover:text-gray-900">
							{t("languageToggle")}
						</button>
					</div>
				</div>
				{isMenuOpen && (
					<div className="md:hidden mt-4 pb-4">
						<a
							href={getLocalizedPath("#features")}
							className="block py-2 text-gray-600">
							{t("Features")}
						</a>
						<a
							href={getLocalizedPath("#pricing")}
							className="block py-2 text-gray-600">
							{t("Pricing")}
						</a>
						<a
							href={getLocalizedPath("#contact")}
							className="block py-2 text-gray-600">
							{t("Contact")}
						</a>
						<a href="/app/">
						<button className="mt-2 w-full bg-blue-500 text-white px-6 py-2 rounded-full">{t("Log In")}</button>
						</a>
						<button
							onClick={switchLanguage}
							className="block mt-4 text-gray-600">
							{t("languageToggle")}
						</button>
					</div>
				)}
			</div>
		</nav>
	);
};

export default Navigation;
